import { render } from "./AlmacenForm.vue?vue&type=template&id=a4d20008&scoped=true"
import script from "./AlmacenForm.vue?vue&type=script&lang=js"
export * from "./AlmacenForm.vue?vue&type=script&lang=js"

import "./AlmacenForm.vue?vue&type=style&index=0&id=a4d20008&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d20008"]])

export default __exports__